import { merge } from "lodash";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { ChoiceComponents, ChoiceStores } from "../react_isomorphic/choice";

window.ReactComponents = merge({},
  GlobalComponents,
  ChoiceComponents
);

window.ReactStores = merge({},
  GlobalStores,
  ChoiceStores
);
